<div class="modal-container">
  <h2 class="modal-title"> Confirmation </h2>
  <div class="modal-content">
    <p _ngcontent-onc-c259="" class="modal-text">
      You're about to save <br />
      <b>"{{ modelName }}"</b> in the <b>"{{ workspaceName }}"</b>.<br />
      Are you sure you want to proceed?
    </p>
    <p class="modal-info"> You can edit this model at any time after saving. </p>
  </div>

  <div class="modal-actions">
    <button class="btn btn-secondary" (click)="onCancel()"> NO </button>
    <button class="btn btn-primary" (click)="onConfirmSave()"> YES </button>
  </div>
</div>
